import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer: React.FC = ( ) => {

    const { t } = useTranslation();

    interface FooterSection {
        title: string;
        links: FooterLink[];
    }
    interface FooterLink {
        text: string;
        url: string;
    }

    const footerSearchLink: { [key: string]: FooterSection } = {
        "sell": {
            title: t('footer.searchLinks.sell.title'),
            links: [
                { text: t('footer.searchLinks.sell.link1'), url: '/immobili/vendita/lucca/forte-dei-marmi' },
                { text: t('footer.searchLinks.sell.link2'), url: '/immobili/vendita/lucca/pietrasanta' },
                { text: t('footer.searchLinks.sell.link3'), url: '/immobili/vendita/lucca/viareggio' },
                { text: t('footer.searchLinks.sell.link4'), url: '/immobili/vendita/lucca/camaiore' },
            ]
        },
        "rent": {
            title: t('footer.searchLinks.rent.title'),
            links: [
                { text: t('footer.searchLinks.rent.link1'), url: '/immobili/affitto/lucca/forte-dei-marmi' },
                { text: t('footer.searchLinks.rent.link2'), url: '/immobili/affitto/lucca/pietrasanta' },
                { text: t('footer.searchLinks.rent.link3'), url: '/immobili/affitto/lucca/viareggio' },
                { text: t('footer.searchLinks.rent.link4'), url: '/immobili/affitto/lucca/camaiore' },
            ]
        }
    };

    return (
        <footer className="footer space-pt pb-3 bg-dark">
            <div className="container-fluid w-90 mt-5">
                
                <div className="row">
                    <div className="col-6 col-md-4 col-lg-3 col-xl-2 mb-5">
                        <img src="/assets/images/logo-gold.png" alt="Logo" className="img-fluid" />
                    </div>
                </div>

                <div className="row mb-5">
                    {Object.keys(footerSearchLink).map((key) => {
                        const section = footerSearchLink[key];
                        return (
                            <div className="col-md-4 mb-4" key={key}>
                                <h5 className="text-white mb-3">{section.title}</h5>
                                <ul className="list-unstyled">
                                    {section.links.map((link, index) => (
                                        <li key={index}>
                                            <a href={link.url} className="text-white">{link.text}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>

                <div className="row justify-content-between">
                    <div className="col-12 col-lg-auto">
                        <ul className="list-unstyled d-flex flex-wrap gap-3">
                            <li className="mr-3">
                                <Link to="/immobili" className="text-white text-uppercase">{t('footer.searchText')}</Link>
                            </li>
                            <li className="mr-3">
                                <Link to="/vendi" className="text-white text-uppercase">{t('footer.valuationText')}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-12 col-lg-auto">
                        <ul className="list-unstyled d-flex flex-wrap gap-3">
                            <li className="mr-3">
                                <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="text-white">YOUTUBE</a>
                            </li>
                            <li className="mr-3">
                                <a href="https://www.instagram.com/splendida.re" target="_blank" rel="noopener noreferrer" className="text-white">INSTAGRAM</a>
                            </li>
                            <li className="mr-3">
                                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white">LINKEDIN</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <hr className="bg-white" />

                <div className="row justify-content-between">
                    <div className="col-12 col-lg-auto text-white">
                        <p className='d-inline-block'>© SPLENDIDA S.R.L.S</p>
                        <span> - </span>
                        <Link to="/dati" className="text-white">Dati Societari</Link>
                        <span> - </span>
                        <Link to="/privacy" className="text-white">Privacy</Link>
                        <span> - </span>
                        <Link to="/cookies" className="text-white">Cookies</Link>
                    </div>
                    <div className="col-12 col-lg-auto">
                        <p className='text-white d-inline-block'>{t('footer.para1')}</p>
                    </div>    
                </div>


            </div>
        </footer>
    );
}

export default Footer;